function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { useBuildStyleWithTheme } from "../../ThemeProvider/useBuildStyleWithTheme";
function buildStyle(param, param1) {
    var backgroundColor = param.backgroundColor, borderColor = param.borderColor, font = param.font, size = param.size, readingDirection = param1.readingDirection, end = param1.end, start = param1.start;
    var _obj, _obj1, _obj2, _obj3;
    return {
        base: _objectSpread({}, readingDirection, (_obj3 = {
            borderRadius: size.border.radius.fiveX,
            marginTop: 0,
            marginBottom: 0
        }, _defineProperty(_obj3, start.margin, 8), _defineProperty(_obj3, end.margin, 8), _defineProperty(_obj3, '&:hover', {
            backgroundColor: backgroundColor.click.hover
        }), _defineProperty(_obj3, '&:active', {
            backgroundColor: backgroundColor.click.active
        }), _defineProperty(_obj3, "a", _objectSpread({}, readingDirection, (_obj2 = {
            display: 'flex',
            minHeight: 40,
            alignItems: 'center',
            textDecoration: 'none',
            color: font.color.fill,
            fontSize: font.base.size.m,
            fontWeight: font.base.weight.regular,
            paddingTop: 4,
            paddingBottom: 4
        }, _defineProperty(_obj2, start.padding, 16), _defineProperty(_obj2, end.padding, 16), _defineProperty(_obj2, "cursor", 'pointer'), _defineProperty(_obj2, "borderRadius", size.border.radius.fiveX), _defineProperty(_obj2, "boxSizing", 'border-box'), _defineProperty(_obj2, '&:hover', {
            '& span > svg > g': {
                fill: "".concat(font.color.fill, " !important")
            }
        }), _defineProperty(_obj2, '&:focus-visible', {
            outline: 0,
            boxShadow: "0 0 0 ".concat(size.border.focus, "px ").concat(borderColor.neutral.fill.focus)
        }), _defineProperty(_obj2, '& svg', {
            width: '20px !important',
            height: '20px !important',
            '& g': {
                fill: "".concat(font.color.fill, " !important")
            }
        }), _defineProperty(_obj2, '& span', (_obj1 = {}, _defineProperty(_obj1, end.margin, 16), _defineProperty(_obj1, "display", 'flex'), _defineProperty(_obj1, "alignItems", 'center'), _defineProperty(_obj1, "color", font.color.fill), _defineProperty(_obj1, "fontSize", font.base.size.m), _defineProperty(_obj1, "fontWeight", font.base.weight.regular), _defineProperty(_obj1, '& > span', (_obj = {
            height: 24,
            width: 20,
            display: 'flex',
            alignItems: 'center'
        }, _defineProperty(_obj, end.margin, 16), _defineProperty(_obj, '& svg', {
            width: '20px !important',
            height: '20px !important',
            '& g': {
                fill: "".concat(font.color.fill, " !important")
            }
        }), _obj)), _obj1)), _defineProperty(_obj2, '& div', {
            minWidth: '75%',
            overflowWrap: 'break-word'
        }), _obj2))), _obj3))
    };
}
export default function useStyle(isRtl) {
    var builtStyle = useBuildStyleWithTheme(buildStyle, {
        isRtl: isRtl
    });
    if (!builtStyle) {
        return {
            menuItemStyles: {}
        };
    }
    var base = builtStyle.base;
    return {
        menuItemStyles: base
    };
};
